import "normalize.css";

import {
  Aurora,
  Carousels,
  Footer,
  HeaderNav,
  Hero,
  Newsletter,
  SmoothScroll,
} from "./services";

class App {
  mainContainer: HTMLElement;

  smoothScroll: SmoothScroll;

  hasLoadedPage = false;

  constructor() {
    this.mainContainer = document.getElementById("page")!;
    this.smoothScroll = new SmoothScroll();

    this.init();
  }

  init = async () => {
    this.setMainContainerProperties();

    window.addEventListener("resize", this.setMainContainerProperties);

    new HeaderNav();

    const auroraCanvasContainer = document.querySelector(
      ".aurora-canvas-container",
    ) as HTMLElement | null;

    if (auroraCanvasContainer) {
      new Aurora();
    }

    new Hero();
    new Carousels(this.smoothScroll);
    new Newsletter(this.smoothScroll);
    new Footer();
  };

  setMainContainerProperties = () => {
    const windowWidth = window.innerWidth;
    const contentMaxWidth = getComputedStyle(
      this.mainContainer,
    ).getPropertyValue("--content-max-width");

    const normalizedContentMaxWidth = Math.min(
      windowWidth,
      parseInt(contentMaxWidth),
    );

    const horizontalMarginToContent =
      (windowWidth - normalizedContentMaxWidth) * 0.5;

    document.body.style.setProperty(
      "--content-horizontal-offset",
      `${horizontalMarginToContent}px`,
    );

    const contentPaddingInline = parseInt(
      getComputedStyle(document.body).getPropertyValue(
        "--content-padding-inline",
      ),
    );

    const contentInnerWidth =
      normalizedContentMaxWidth - contentPaddingInline * 2;

    document.body.style.setProperty(
      "--content-inner-width",
      `${contentInnerWidth}px`,
    );
  };
}

new App();
